import { render, staticRenderFns } from "./DetailBillClosed.vue?vue&type=template&id=350681d8"
import script from "./DetailBillClosed.vue?vue&type=script&lang=js"
export * from "./DetailBillClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports